import React, {
  createContext,
  useContext,
} from "react";

import useVisitorAdminAlerts, {
  EMPTY_VISITOR_ADMIN_SUMMARY,
} from "../hooks/useVisitorAdminAlerts";

const VisitorAdminAlertsContext =
  createContext({
    summary: EMPTY_VISITOR_ADMIN_SUMMARY,
    loading: false,
    errorMessage: "",
    refresh: async () => null,
  });

export function VisitorAdminAlertsProvider({
  children,
  enabled = false,
  pollMs = 8000,
}) {
  const visitorAlerts =
    useVisitorAdminAlerts({
      enabled,
      pollMs,
    });

  return (
    <VisitorAdminAlertsContext.Provider
      value={visitorAlerts}
    >
      {children}
    </VisitorAdminAlertsContext.Provider>
  );
}

export function useVisitorAdminAlertsContext() {
  return useContext(
    VisitorAdminAlertsContext,
  );
}